import { Container, Grid, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { FormularioDeudas } from "../../componentes/Deudas/Formulario";
import { useCasUserContext } from "../../services/casUserContext";
import { ObligacionDTO, VoidObligacionDTO } from "../../interfaces/Deudas/DeudasDTO";
import AlertService from "../../services/AlertService";
import FondoRotativoService from "../../services/FondoRotativoService";
import { useEffect, useState } from "react";

const alerta = new AlertService();
const fondos = new FondoRotativoService();

export const FormularioDeudasPage: React.FC<{}> = () => {
    let history = useNavigate();
    const { id } = useParams<{ id: string }>();
    const casUserContext = useCasUserContext();
    const token = casUserContext.token;
    const idcreador = casUserContext.userData.idpersona;
    const [loading, setLoading] = useState(false)
    const [obligacion, setObligacion] = useState(VoidObligacionDTO());

    useEffect(() => {
        Get(Number(id));
    },[])

    const goToNavigation = (site: string) => {
        history(site)
    }

    const Get = async (id: number) => {
        //console.log(obj);
        setLoading(true);
        alerta.showLoading("Espere...");
        await fondos.GetObligacionById(id, token)
            .then((data) => {
                console.log(data.data)
                if (data.status.isSuccessfully) {
                    setObligacion(data.data)
                } else {
                    alerta.alertaAdvertenciaList('Alerta', data.status.messages);
                }
            })
            .catch((error) => { console.error(error) })
            .finally(() => {
                setLoading(false);
                alerta.hideLoading();
            })
    }
    
    const Post = async (values: ObligacionDTO) => {
        //console.log(obj);
        alerta.showLoading("Espere...");
        await fondos.IngresarObligacion(values, token)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    alerta.hideLoading();
                    alerta.alertaExito('Éxito', 'Se registro la obligación');
                    goToNavigation('/Deudas')
                } else {
                    alerta.hideLoading();
                    alerta.alertaAdvertenciaList('Alerta', data.status.messages);
                }
            })
            .catch((error) => { console.error(error) })
            .finally(() => {
                alerta.hideLoading();
            })
    }

    const Put = async (values: ObligacionDTO) => {
        console.log(values);
        alerta.showLoading("Espere...");
        await fondos.ActualizarObligacion(values.iddecinvobligacion, values, token)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    alerta.hideLoading();
                    alerta.alertaExito('Éxito', 'Se actualizó la obligación');
                    goToNavigation('/Deudas')
                } else {
                    alerta.hideLoading();
                    alerta.alertaAdvertenciaList('Alerta', data.status.messages);
                }
            })
            .catch((error) => console.error(error))
            .finally(() => {
                alerta.hideLoading();
            })
    }

    return (
        <Container sx={{ mt: 5, mb: 4, border: '1px solid #517ED3', borderRadius: '5px', padding: '20px', textAlign: 'center' }}>
            <br />
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                    <Typography variant="h6"><strong>Formulario de Deudas Institucionales</strong></Typography>
                </Grid>
                <Grid item xs={12}>
                    {loading ?
                        <></>
                        : <FormularioDeudas obligacion={obligacion} token={token} idcreador={idcreador}
                        Post={Post}
                        Put={Put} />
                    }
                </Grid>
            </Grid>
        </Container>
    );
}